import axios from "axios";
import { connection_platform } from "../api";
import { format } from "date-fns";

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
port = localStorage.getItem("port");
var checkreply = false;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn`;

//PEGAR MIDIAS
export async function getMidias() {
  try {
    const response = await axios.get(`${apiBaseUrl}/midiascampaign`);

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// NÍVEL DO NPS
export async function getNpsResult(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-nps-result?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSentSurveys(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-sent-surveys?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getNpsQuest(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  type,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-nps-quest?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&type=${type}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getServicesPerformed(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-services-performed?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCsatResult(
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-result?idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCsatChannel(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-midia?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getResearchHandled(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-research-handled?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// CSAT MÊS
export async function getCsatDay(negocioId, unidadId, npsId, csatId, midiaId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-day?idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// CSAT POR MÍDIA
export async function getCsatDayChannel(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-day-midia?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// TABELA DE UNIDADES
export async function getUnityList(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  userId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-unity-list?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&iduser=${userId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getUnityListUngrouped(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  userId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-unity-list-ungrouped?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&iduser=${userId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertNameUnitGroup(description, userId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/insert-service-unit-group?description=${description}&iduser=${userId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function deleteNameUnitGroup(idsug, userId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/delete-service-unit-group?idsug=${idsug}&iduser=${userId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function listNameUnitGroup(userId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-service-unit-group?iduser=${userId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function listUnitGroup(userId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-service-unit-associate?iduser=${userId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertUnitGroup(idsug, idserviceunit) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/insert-service-unit-associate?idsug=${idsug}&idserviceunit=${idserviceunit}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function deleteUnitGroup(idsug, idserviceunit, userId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/delete-service-unit-associate?idsug=${idsug}&idserviceunit=${idserviceunit}&iduser=${userId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// MAPEAMENTO DE PERFIL
export async function getProfileMapping(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  source,
  setLoading,
  npsId,
  csatId,
  midiaId,
) {
  try {
    setLoading(true);
    const response = await axios.get(
      `${apiBaseUrl}/get-profile-mapping?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
      { cancelToken: source.token },
    );

    setLoading(false);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelado pelo usuário: ", error);
    } else {
      console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
      setLoading(false);
    }
  }
}

// TAXA DE COMPILAÇÃO
export async function getCompilationRate(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-compilation-rate?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// TAXA DE RESPOSTA
export async function getAnswerRate(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-answer-rate?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// MAPA DE HUMOR
export async function getMoodMap(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-mood-map?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// ########################################### ROTAS PARA FILTROS DO NPS ###########################################
export async function getBusiness() {
  try {
    let response = await axios.get(`${apiBaseUrl}/get-business-unit`);

    return response;
  } catch (error) {
    console.log("GET ERROR: ", error);
  }
}

export async function getUnits() {
  try {
    let response = await axios.get(`${apiBaseUrl}/get-service-unit`);

    return response;
  } catch (error) {
    console.log("GET ERROR: ", error);
  }
}

export async function getQuestionsNPSCSAT() {
  try {
    let response = await axios.get(`${apiBaseUrl}/get-questions-nps-csat`);

    return response;
  } catch (error) {
    console.log("GET ERROR: ", error);
  }
}

//

// ########################################### ROTAS DA PARTE DE INDICADORES ###########################################
export async function indicatorsAgeRange(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    // &idnegocio=${negocioId}&idunidade=${unidadId}
    const response = await axios.get(
      `${apiBaseUrl}/get-age-range-nps?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function indicatorsNotes(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    // &idnegocio=${negocioId}&idunidade=${unidadId}
    const response = await axios.get(
      `${apiBaseUrl}/get-gender-nps?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function indicatorsGeneral(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    // &idnegocio=${negocioId}&idunidade=${unidadId}
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-answers?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// ########################################### ROTAS PARA TELA DE TRATIVAS ###########################################
export async function acceptAnswer(
  serviceId,
  user_response,
  id_ideal_status,
  cdrid,
  changed_profile,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/insert-deal?idatendimento=${serviceId}&user_response=${user_response}&id_ideal_status=${id_ideal_status}&cdrid=${cdrid}&changed_profile${false}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function listDeals(
  startDate,
  endDate,
  unitId,
  businessId,
  attendantId,
  orderOfService,
  profile,
  cdrid,
  npsId,
  csatId,
  midiaId,
  perfil,
) {
  try {
    // const response = await axios.get(`${apiBaseUrl}/get-deal?datestart=${startDate}&dateend=${dateEnd}&idunidade=${unitId}&idatendente=${attendantId}&ordemservico=${orderOfService}&perfil=${profile}&cdrid=${cdrid}`);
    const dateStart = format(new Date(startDate), "yyyy-MM-dd");
    const dateEnd = format(new Date(endDate), "yyyy-MM-dd");
    const response = await axios.get(
      `${apiBaseUrl}/get-deal?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idatendente=&ordermservico=&perfil=${perfil}&cdrid=&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getDealStatus() {
  try {
    const response = await axios.get(`${apiBaseUrl}/get-deal-status`);

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCommentHistoric(serviceattendantid) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-evaluation-comment?serviceattendantid=${serviceattendantid}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getDealHistoric(phone) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-deal-historic?phone=${phone}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function deleteEvaluation(attendanceId) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/delete-evaluation?idatendimento=${attendanceId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

// ########################################### ROTAS PARA TELA DE RANKINGS ###########################################
export async function getUnityTableContent(
  startDate,
  endDate,
  idUnit,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-ranking-unity?datestart=${startDate}&dateend=${endDate}&idunidade=${idUnit}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    //

    const rawData = response.data;
    let formatedData = [];

    if (rawData && rawData.length) {
      function groupBy(arr, key) {
        return arr.reduce((result, item) => {
          const groupKey = item[key];

          if (!result[groupKey]) {
            result[groupKey] = [];
          }

          result[groupKey].push(item);

          return result;
        }, {});
      }

      function groupInfo(rawData) {
        const groupedData = groupBy(rawData, "idunidade");

        const formatedData = [];

        if (rawData && rawData.length) {
          for (const id in groupedData) {
            let qtde = 0;
            let qtde_envio = 0;
            let qtde_avaliada = 0;
            let promoter = 0;
            let neutral = 0;
            let detractor = 0;

            groupedData[id].forEach((data) => {
              const rawQtde = Number(data.qtde) ? Number(data.qtde) : 0;
              const rawQtdeSend = Number(data.qtde_envio)
                ? Number(data.qtde_envio)
                : 0;
              const rawQEvaluated = Number(data.qtde_avaliada)
                ? Number(data.qtde_avaliada)
                : 0;

              qtde += rawQtde;
              qtde_envio += rawQtdeSend;
              qtde_avaliada += rawQEvaluated;

              switch (data.nota) {
                case "Promotor" || "promotor":
                  promoter += rawQtde;
                  return;
                case "Detrator" || "detrator":
                  detractor += rawQtde;
                  return;
                case "Neutro" || "neutro":
                  neutral += rawQtde;
                  return;
                default:
                  return;
              }
            });

            formatedData.push({
              idunidade: id,
              unidade: groupedData[id][0].unidade,
              promotor: promoter,
              detrator: detractor,
              neutro: neutral,
              qtde,
              qtde_envio,
              qtde_avaliada,
            });
          }
        }

        return formatedData;
      }

      formatedData = groupInfo(rawData);
    }

    return formatedData ? formatedData : [];
  } catch (error) {
    console.log("getUnityTableContent ERROR: ", error);
    return "ERROR";
  }
}

export async function getHealthInsuranceTableContent(
  startDate,
  endDate,
  idUnit,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-ranking-flat?datestart=${startDate}&dateend=${endDate}&idunidade=${idUnit}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    const rawData = response.data;
    let formatedData = [];

    if (rawData && rawData.length) {
      function groupBy(arr, key) {
        return arr.reduce((result, item) => {
          const groupKey = item[key];

          if (!result[groupKey]) {
            result[groupKey] = [];
          }

          result[groupKey].push(item);

          return result;
        }, {});
      }

      function groupInfo(rawData) {
        const groupedData = groupBy(rawData, "idplano");

        const formatedData = [];

        if (rawData && rawData.length) {
          for (const id in groupedData) {
            let qtde = 0;
            let qtde_envio = 0;
            let qtde_avaliada = 0;
            let promoter = 0;
            let neutral = 0;
            let detractor = 0;

            groupedData[id].forEach((data) => {
              const rawQtde = Number(data.qtde) ? Number(data.qtde) : 0;
              const rawQtdeSend = Number(data.qtde_envio)
                ? Number(data.qtde_envio)
                : 0;
              const rawQEvaluated = Number(data.qtde_avaliada)
                ? Number(data.qtde_avaliada)
                : 0;

              qtde += rawQtde;
              qtde_envio += rawQtdeSend;
              qtde_avaliada += rawQEvaluated;

              switch (data.nota) {
                case "Promotor" || "promotor":
                  promoter += rawQtde;
                  return;
                case "Detrator" || "detrator":
                  detractor += rawQtde;
                  return;
                case "Neutro" || "neutro":
                  neutral += rawQtde;
                  return;
                default:
                  return;
              }
            });

            formatedData.push({
              idplano: id,
              plano: groupedData[id][0].plano,
              promotor: promoter,
              detrator: detractor,
              neutro: neutral,
              qtde,
              qtde_envio,
              qtde_avaliada,
            });
          }
        }

        return formatedData;
      }

      formatedData = groupInfo(rawData);
    }

    return formatedData ? formatedData : [];
  } catch (error) {
    console.log("getHealthInsuranceTableContent ERROR: ", error);
    return "ERROR";
  }
}

// ########################################### ROTAS PARA TELA DE COMPARATIVOS ###########################################

export async function getComparisonsNPS(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-nps-comparison?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export async function getGradeAverage(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-average-nps-comparison?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export async function getEngagement(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-nps-engagement?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export async function getComparisonsProfile(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  profile,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-nps-profile?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&perfil=${profile}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export async function getSearchSended(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-nps-profile-comparison?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export async function getComparisonsNpsXServices(
  yearStart,
  yearEnd,
  businessId,
  unityId,
  profile,
  npsId,
  csatId,
  midiaId,
) {
  try {
    let response = await axios.get(
      `${apiBaseUrl}/get-nps-procedure-comparison?yearstart=${yearStart}&yearend=${yearEnd}&idnegocio=${businessId}&idunidade=${unityId}&perfil=${profile}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );
    const rawData = response.data;
    let dataToRender = [];
    if (rawData && rawData.length) {
      dataToRender = rawData;
    }
    return dataToRender;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return "ERROR";
  }
}

export function getIPBaseURL() {
  return apiBaseUrl;
}

export async function getSentSurveysMidia(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  source,
  setLoading,
  npsId,
  csatId,
  midiaId,
) {
  try {
    setLoading(true);
    const response = await axios.get(
      `${apiBaseUrl}/get-sent-surveys-midia?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
      { cancelToken: source.token },
    );

    setLoading(false);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelado pelo usuário: ", error);
    } else {
      console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
      setLoading(false);
    }
    return [];
  }
}

// ########################################## geração do relatório de qualidade #################################

export async function indicatorsGeneralPdf(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    // &idnegocio=${negocioId}&idunidade=${unidadId}
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-subqual-answers?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSentNpsCsat(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-sent-nps-csat?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCsatQuest(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  type,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-quest?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&type=${type}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingCsat(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-csat?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSentNegotiations(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  profile = "DETRATOR",
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-sent-tratativas?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idatendente=&ordemservico=&perfil=${profile}&cdrid=&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingAdhesion(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-adesao?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingCompletedDeal(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-deal?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingSubqualifiers(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  idOfSubqualifier = "",
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-subqualificadores?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&id_pergunta=${idOfSubqualifier}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSolicitationsList(token) {
  try {
    const config = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    const data = {};
    console.log("config", config);
    const response = await axios.post(
      `${connection_platform.ingDeskBaseUrl}/buscar-tipo-solicitacao`,
      data,
      config,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSlaTickets(
  token,
  idtipo,
  datestart,
  dateend,
  pesquisa,
) {
  try {
    const config = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    let data = null;
    if (pesquisa === true) {
      data = {
        idtipo: null,
        datestart,
        dateend,
        pesquisa,
      };
    } else {
      data = {
        idtipo,
        datestart,
        dateend,
        pesquisa,
      };
    }
    const response = await axios.post(
      `${connection_platform.ingDeskBaseUrl}/buscar-tickets-sla`,
      data,
      config,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getTokenIngDesk(user) {
  try {
    let token = null;
    const data = {
      login_user: user,
      login_master: "ingenium",
      password_master: "52e9f8a1500604b372a5c0908d93ee5f",
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${connection_platform.ingDeskBaseUrl}/login-master-integrationv3`,
      data,
      config,
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const deskData = response.data;
      const hasDeskData = !!deskData;
      if (hasDeskData) {
        token = deskData.token;
      }
    }

    return token;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCsatQuestV2(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  type,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-csat-quest-v2?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&type=${type}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getNpsQuestV2(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  type,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-nps-quest-v2?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&type=${type}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getNpsResultV2(
  dateStart,
  dateEnd,
  negocioId,
  unidadId,
  type,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-nps-result-v2?datestart=${dateStart}&dateend=${dateEnd}&idnegocio=${negocioId}&idunidade=${unidadId}&type=${type}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingCompletedDealTerm(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-deal-term?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingSubqualifiersV2(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  idOfSubqualifier = "",
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-subqualificadores-v2?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&id_pergunta=${idOfSubqualifier}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingSended(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-enviadas?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSlaTicketsV2(
  token,
  idtipo,
  datestart,
  dateend,
  pesquisa,
) {
  try {
    const config = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    let data = null;
    if (pesquisa === true) {
      data = {
        idtipo: null,
        datestart,
        dateend,
      };
    } else {
      data = {
        idtipo,
        datestart,
        dateend,
      };
    }
    const response = await axios.post(
      `${connection_platform.ingDeskBaseUrl}/buscar-tiposolicitacao-sla`,
      data,
      config,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSlaTicketsEspecificV2(
  token,
  idtipo,
  datestart,
  dateend,
  pesquisa,
) {
  try {
    const config = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    let data = null;
    if (pesquisa === true) {
      data = {
        idtipo: null,
        datestart,
        dateend,
      };
    } else {
      data = {
        idtipo,
        datestart,
        dateend,
      };
    }
    const response = await axios.post(
      `${connection_platform.ingDeskBaseUrl}/buscar-motivos-sla`,
      data,
      config,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingEnviadasPlano(
  dateStart,
  dateEnd,
  unitId,
  businessId,
  npsId,
  csatId,
  midiaId,
) {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/get-ranking-enviadas-plano?datestart=${dateStart}&dateend=${dateEnd}&idunidade=${unitId}&idnegocio=${businessId}&idnps=${npsId}&idcsat=${csatId}&idmidia=${midiaId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}
